import { gql } from "@apollo/client";

export const GET_TRAVEL_LANDING_PAGES = gql`
  query GetTravelLandingPages(
    $pageSize: Int
    $pageNumber: Int
    $searchTerm: String
    $pageType: TravelLandingPageType
  ) {
    travelLandingPages(
      pageSize: $pageSize
      pageNumber: $pageNumber
      searchTerm: $searchTerm
      pageType: $pageType
    ) {
      items {
        id
        slug
        name
        status
        pageType
        imageUrl
        updatedAt
        updatedBy
        views
        uniqueVisitors
      }
      count
      pageNumber
      pageSize
    }
  }
`;

export const GET_TRAVEL_LANDING_PAGE = gql`
  query GetTravelLandingPage($id: UUID!) {
    travelLandingPage(id: $id) {
      id
      slug
      name
      status
      pageType
      defaultLocale
      imageUrl
      sections {
        id
        type
        order
        data
        audience {
          mode
          countries
          regions
          cities {
            name
            countryCode
          }
        }
      }
      localeContent {
        key
        value {
          sectionData
          seo {
            title
            description
            ogImage
          }
        }
      }
      createdAt
      updatedAt
      createdBy
      updatedBy
      publishedAt
    }
  }
`;

export const GET_TRAVEL_LANDING_PAGE_VIEWS_SUMMARY = gql`
  query GetTravelLandingPageViewsSummary($id: UUID!, $fromDate: DateTime, $toDate: DateTime) {
    travelLandingPageViewsSummary(id: $id, fromDate: $fromDate, toDate: $toDate) {
      pageViewsCount
      uniqueVisitors
      ctaClicks
      conversionRate
    }
  }
`;

export const GET_TRAVEL_LANDING_PAGE_VIEWS_DAILY = gql`
  query GetTravelLandingPageViewsDaily($id: UUID!, $fromDate: DateTime, $toDate: DateTime) {
    travelLandingPageViewsDaily(id: $id, fromDate: $fromDate, toDate: $toDate) {
      date
      count
    }
  }
`;

export const GET_TRAVEL_LANDING_PAGE_CTA_BREAKDOWN = gql`
  query GetTravelLandingPageCtaBreakdown($id: UUID!, $fromDate: DateTime, $toDate: DateTime) {
    travelLandingPageCtaBreakdown(id: $id, fromDate: $fromDate, toDate: $toDate) {
      sectionId
      itemId
      clicks
    }
  }
`;

// Aggregated analytics for all landing pages (dashboard)
export const GET_TRAVEL_LANDING_PAGES_ANALYTICS_SUMMARY = gql`
  query GetTravelLandingPagesAnalyticsSummary($fromDate: DateTime, $toDate: DateTime) {
    travelLandingPagesAnalyticsSummary(fromDate: $fromDate, toDate: $toDate) {
      totalPageViews
      totalUniqueVisitors
      totalCtaClicks
      averageConversionRate
      topPages {
        id
        name
        slug
        views
        uniqueVisitors
        ctaClicks
        conversionRate
      }
    }
  }
`;

export const GET_TRAVEL_LANDING_PAGES_VIEWS_DAILY = gql`
  query GetTravelLandingPagesViewsDaily($fromDate: DateTime, $toDate: DateTime) {
    travelLandingPagesViewsDaily(fromDate: $fromDate, toDate: $toDate) {
      date
      count
    }
  }
`;

export const GET_TRAVEL_LANDING_PAGES_TOP_PERFORMERS = gql`
  query GetTravelLandingPagesTopPerformers($fromDate: DateTime, $toDate: DateTime, $limit: Int) {
    travelLandingPagesTopPerformers(fromDate: $fromDate, toDate: $toDate, limit: $limit) {
      id
      name
      slug
      views
      uniqueVisitors
      ctaClicks
      conversionRate
    }
  }
`;
